import React from "react";
import { FaInfoCircle } from "react-icons/fa";

import {
  cn,
  getMemberFullName,
  hasMemberDetails,
  toAbsoluteTeamPhoto,
} from "./teamUtils";

const FALLBACK_AVATAR = "/img/user_avatar.jpg";

export default function TeamCard({
  member,
  categoryStyle,
  indexInCategory,
  onOpen,
}) {
  const photo = toAbsoluteTeamPhoto(member?.photoURL) || FALLBACK_AVATAR;
  const hasDetails = hasMemberDetails(member);
  const fullName = getMemberFullName(member);

  return (
    <article
      className={cn(
        "group relative h-full overflow-hidden rounded-[1.5rem]",
        "border border-slate-200 bg-white shadow-sm",
        "transition duration-300 hover:-translate-y-1.5 hover:shadow-xl",
        "dark:border-white/10 dark:bg-slate-900"
      )}
      style={{
        animationDelay: `${Math.min(indexInCategory, 10) * 50}ms`,
      }}
    >
      <div className="relative h-44 overflow-hidden sm:h-48 lg:h-52">
        <img
          src={photo}
          alt={fullName || "Membre du club"}
          loading="lazy"
          decoding="async"
          className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
          onError={(event) => {
            event.currentTarget.src = FALLBACK_AVATAR;
          }}
        />

        <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/25 to-transparent" />

        {hasDetails && (
          <button
            type="button"
            onClick={() => onOpen(member)}
            className="absolute right-3 top-3 z-20 flex h-9 w-9 items-center justify-center rounded-full border border-white/20 bg-white/20 text-white shadow-lg backdrop-blur-xl transition hover:scale-105 hover:bg-primary hover:text-white"
            aria-label={`Voir le profil de ${fullName}`}
            title="Voir le profil"
          >
            <FaInfoCircle className="text-sm" />
          </button>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="font-barlow text-lg font-extrabold uppercase leading-tight text-white drop-shadow-lg sm:text-xl">
            {member?.nom}
          </h3>

          <p className="font-barlow text-sm font-bold leading-tight text-white/90 sm:text-base">
            {member?.prenom}
          </p>
        </div>
      </div>

      <div className="flex flex-1 flex-col p-4 pb-5">
        <div className="flex min-h-[50px] items-center justify-center rounded-2xl bg-slate-50 px-3 py-2 text-center text-xs font-bold leading-5 text-slate-600 dark:bg-white/5 dark:text-slate-300">
          <span className="line-clamp-2">{member?.fonction || ""}</span>
        </div>
      </div>

      <div
        aria-hidden
        className={cn(
          "absolute bottom-0 left-0 right-0 h-1.5 bg-gradient-to-r",
          categoryStyle.gradient
        )}
      />
    </article>
  );
}